import React from 'react';

const ConnectAsContext = React.createContext({
  isConnectedAs: true,
  session: null,
  connectAs: () => {},
  terminateSession: () => {},
});

export default ConnectAsContext;
